import { render, staticRenderFns } from "./FilesAppSettingsWarnings.vue?vue&type=template&id=02608f74"
import script from "./FilesAppSettingsWarnings.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilesAppSettingsWarnings.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports